// FIX-CCS-G-GPS G4 — canonical JSON (sorted keys, recursively; undefined dropped). The same algorithm as the server copy in
// supabase/functions/upload-photo/locationBundle.ts, which recomputes bundle_sha256 over the same text.
export function canonicalJson(v: unknown): string {
  if (v === null || typeof v !== 'object') return JSON.stringify(v);
  if (Array.isArray(v)) return '[' + v.map(canonicalJson).join(',') + ']';
  const o = v as Record<string, unknown>;
  return '{' + Object.keys(o).filter((k) => o[k] !== undefined).sort().map((k) => JSON.stringify(k) + ':' + canonicalJson(o[k])).join(',') + '}';
}
